import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, CardTitle, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import { ImageIcon } from 'lucide-react';

const ErrorPage = () => {
    return <Card>
        <CardHeader>
            <CardTitle icon={<ImageIcon />}>Company Logo</CardTitle>
        </CardHeader>
        <CardContent>
            <Typography variant='body1'>
                We're sorry, there is a problem with the current request. Details regarding this message have been logged. Please try again and <a href='mailto:issuers@otcmarkets.com'>Contact us</a> if the problem continues.
            </Typography>
        </CardContent>
    </Card>;
};

ErrorPage.propTypes = {
    className: PropTypes.string
};

export default ErrorPage;
